import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _hasUnsavedChanges = signal<boolean>(false);
    readonly unsavedChanges = this._hasUnsavedChanges.asReadonly();

    constructor() {
        window.addEventListener('beforeunload', (event) => {
            if (this._hasUnsavedChanges()) {
                event.preventDefault();
                event.returnValue = 'Sie haben Ihre Eingaben nicht gespeichert. Wollen Sie die Seite ohne Speichern verlassen?';
            }
        });
    }

    setUnsavedChanges(hasChanges: boolean) {
        this._hasUnsavedChanges.set(hasChanges);
    }

    getUnsavedChanges(): boolean {
        return this._hasUnsavedChanges();
    }
}